import { Mark, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    fontWeight: {
      setFontWeight: (weight: string) => ReturnType;
    };
  }
}

export const FontWeight = Mark.create({
  name: "fontWeight",
  addAttributes() {
    return {
      weight: {
        default: null,
        parseHTML: (element) => element.style.fontWeight,
        renderHTML: (attributes) => {
          if (!attributes.weight) return {};
          return { style: `font-weight: ${attributes.weight}` };
        },
      },
    };
  },
  parseHTML() {
    return [{ style: "font-weight" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setFontWeight:
        (weight: string | number) =>
        ({ commands }) =>
          commands.setMark(this.name, { weight }),
    };
  },
});


